<template>
  <agile :options="destacadoCarouselConfig">
    <div v-for="destacado in destacados" :key="destacado.id" class="p-1">
      <Link :href="$route('company.stand', destacado.id)">
        <div
          class="p-2 cursor-pointer rounded-2xl transition-shadow duration-300 hover:elevation-2 hover:transition-shadow hover:duration-300"
        >
          <img :src="destacado.logo_url" class="block mx-auto object-cover img-logo" />
        </div>
      </Link>
    </div>
  </agile>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue'
import { VueAgile } from 'vue-agile'
import destacadoCarouselConfig from '@/destacadoCarouselConfig.mixin.js'

export default {
  name: 'DestacadoCarousel',
  components: {Link, agile: VueAgile },
  mixins: [destacadoCarouselConfig],
}
</script>

<style lang="scss" scoped>
.img-logo{
    max-width: 100px;
}
</style>
